import dayjs from "dayjs";
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/en'
import 'dayjs/locale/id'
import api from "../../api";
import { blobToFile } from "../../utils";
import galleryAdapter from '../gallery/adapter'
dayjs.extend(localizedFormat)

const subAdapter = {
  gallery: galleryAdapter,
  location: {
    formToRequestBody(input = {}){
      let result = {
        typeVisibility: 1
      };

      const {
        province,
        city,
        address,
        pin_point
      } = input

      if(province && city && address && pin_point){
        if(province){
          result.provinsi = province.value
        }

        if(city){
          result.kota = city
        }

        if(address){
          result.jalan = address
        }

        if(pin_point){
          result.pinLocation = pin_point
        }

        return {
          lokasi: [result]
        }
      }

      return result
    },
    responseBodyToRender(data){
      let result = ''

      if(data){
        const {jalan, kota, provinsi} = data

        if(jalan){
          result += jalan
        }
        if(kota){
          result += jalan ? `, ${kota}` : kota
        }
        if(provinsi){
          result += jalan || kota ? `, ${provinsi}` : provinsi
        }
      }

      return result === '' ? '-' : result
    }
  },
  location_online: {
    formToRequestBody(input){
      let output = {}

      if(input){
        const {
          location_online_channel = {value: null},
          location_online_url,
          location_online_email,
          location_online_phone,
          event_start_date
        } = input

        output = {
          "typeChannel": location_online_channel.value,
          "url": location_online_url,
          "jadwal": event_start_date,
          "contactPerson": location_online_email,
          "telpReservasi": location_online_phone,
          "typeVisibility": 1
        }
      }

      return output
    },
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          typeChannel = {
            id: null,
            nama: []
          },
          url,
          // jadwal,
          contactPerson,
          telpReservasi,
          // typeVisibility
        } = input

        output = {
          platform_id: typeChannel.id,
          channel: typeChannel?.nama?.[0],
          url,
          email: contactPerson,
          phone: telpReservasi,
        }
      }

      return output
    },
    responseBodyToString(input){
      let output = ''

      if(input){
        const {
          typeChannel = {
            id: null,
            nama: []
          },
        } = input

        output = typeChannel?.nama?.[0]
      }

      return output
    }
  },
  city: {
    responseBodyToRender(input = []){
      let result = ''

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];
          const { kota } = element
          result += index < input.length-1 ? `${kota}, ` : kota
        }
      } else {
        result = '-'
      }

      return result
    }
  },
  extension: {
    formToRequestBody(input = {}){
      let result = {}

      if(input){
        const {
          external_link,
          guest_seat,
          event_start_date,
          event_start_time,
          event_end_date,
          event_end_time,
          registration_start_date,
          registration_start_time,
          registration_end_date,
          registration_end_time,
          note
        } = input

        result = {
          urlRegistrasiEksternal: external_link,
          participantSeat: guest_seat,
          tanggalMulai: subAdapter.date_time.formToRequestBody(event_start_date, event_start_time),
          tanggalSelesai: subAdapter.date_time.formToRequestBody(event_end_date, event_end_time),
          registrationStartDate: subAdapter.date_time.formToRequestBody(registration_start_date, registration_start_time),
          // registrationEndDate: new Date(registration_end_date).toISOString(),
          registrationEndDate: subAdapter.date_time.formToRequestBody(registration_end_date, registration_end_time),
          // submission: null,
          statusActivity: 2,
          // cancelReason: null,
          rescheduleNote: note
          // createdDate: "2020-10-13T09:50:32.777874",
          // isArchieved: 0,
          // typeVisibility: 1,
          // typeSensitivity: 1,
        }
      }

      return result
    }
  },
  image: {
    async formToRequestBody({image, thumbnail}){
      let result = new FormData()

      if(image){
        const { blob, name, type } = image
        const file = await blobToFile(blob, name, type)
        if(file){
          result.append('imgMainImage', file)
        }
      }

      if(thumbnail){
        const { blob, name, type } = thumbnail
        const file = await blobToFile(blob, name, type)
        if(file){
          result.append('imgThumbnail', file)
        }
      }

      return result
    }
  },
  testimonial: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          pkTestimoniUserId,
          deskripsi,
          userId
        } = input
        output = {
          id: pkTestimoniUserId,
          text: deskripsi,
          name: userId?.namaIndividu,
          image: userId && userId.imgFotoProfile ? api.base_image+userId.imgFotoProfile : undefined
        }
      }

      return output
    }
  },
  testimonial_external: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          pkTestimoniNonUserId,
          nama,
          imgFoto,
          deskripsi,
        } = input
        output = {
          id: pkTestimoniNonUserId,
          text: deskripsi,
          name: nama,
          image: api.base_image+imgFoto
        }
      }

      return output
    }
  },
  comment: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          commentId,
          deskripsiComment,
          userId,
          tanggalJam
        } = input
        output = {
          id: commentId,
          user: {
            id: userId?.userId,
            name: userId?.namaIndividu,
            image: userId && userId.imgFotoProfile ? api.base_image+userId.imgFotoProfile : undefined,
          },
          datetime: tanggalJam,
          date: dayjs(tanggalJam).format('MMM DD, YYYY [at] HH:mm a'),
          date_by_language: {
            en: dayjs(tanggalJam).format('MMM DD, YYYY [at] HH:mm a'),
            id: dayjs(tanggalJam).locale('id').format('DD MMMM YYYY [pukul] HH:mm')
          },
          text: deskripsiComment,
        }
      }

      return output
    }
  },
  participant: {
    responseBodyToRender(input, type){
      let output = {}

      if(input){
        const id = type === 'internal' ? input.pkParticipantInternalId : input.pkParticipantEksternalId
        const pkId = id
        const userId = type === 'internal' ? input.userId : undefined
        const name = type === 'internal' ? input.namaIndividu : input.nama
        const {
          nomorTiket,
          activityOrganizingId,
          email,
          pekerjaan = {nama: []},
          telepon,
          typeDifable = {nama: []},
          typeGender = {nama: []},
        } = input

        const occupation = pekerjaan && pekerjaan !== null ? pekerjaan : {nama: []}
        const disability = typeDifable && typeDifable !== null ? typeDifable : {nama: []}
        const gender = typeGender && typeGender !== null ? typeGender : {nama: []}

        output = {
          id,
          pkId,
          userId,
          name,
          order_number: nomorTiket,
          extensionId: activityOrganizingId,
          email,
          occupation: {
            id: occupation.nama[0],
            en: occupation.nama[1]
          },
          phone: telepon,
          disability: {
            id: disability.nama[0],
            en: disability.nama[1]
          },
          disability_status: {
            id: disability.nama[0],
            en: disability.nama[1]
          },
          gender: {
            id: gender.nama[0],
            en: gender.nama[1]
          }
        }
      }

      return output
    },
    responseBodyToMap(internal = [], external = []){
      let output = {}

      for (let index = 0; index < internal.length; index++) {
        const participant = internal[index];
        output[participant.pkParticipantInternalId] = subAdapter.participant.responseBodyToRender(participant, 'internal')
      }

      for (let index = 0; index < external.length; index++) {
        const participant1 = external[index];
        output[participant1.pkParticipantEksternalId] = subAdapter.participant.responseBodyToRender(participant1, 'external')
      }

      return output
    }
  },
  participant_external: {
    responseBodyToRender(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          // const element = input[index];
          // const {
          //   mail: "test@email.com"
          //   feedback: "N/A"
          //   kehadiran: {id: 1, nama: ["Hadir", "Hadir"]}
          //   nama: "test"
          //   nomorTiket: "20210304_c6ttzw6tx"
          //   opsiSatisfaction: 0
          //   pekerjaan: {id: 2, nama: ["Project Officer", "Project Officer"]}
          //   pkParticipantEksternalId: "KZcpIRSr"
          //   preferedNotification: 1
          //   systemRowId: "PlIzfvOb"
          //   telepon: "085612341234"
          //   typeDifable: {id: 0, nama: ["Tidak Ada"]}
          //   typeGender: {id: 1, nama: ["Men", "Men"]}
          //   userYangMendaftarkan: 68104779
          // } = element
          // output.push({
          //   email: "test@email.com"
          //   feedback: "N/A"
          //   kehadiran: {id: 1, nama: ["Hadir", "Hadir"]}
          //   nama: "test"
          //   nomorTiket: "20210304_c6ttzw6tx"
          //   opsiSatisfaction: 0
          //   pekerjaan: {id: 2, nama: ["Project Officer", "Project Officer"]}
          //   pkParticipantEksternalId: "KZcpIRSr"
          //   preferedNotification: 1
          //   systemRowId: "PlIzfvOb"
          //   telepon: "085612341234"
          //   typeDifable: {id: 0, nama: ["Tidak Ada"]}
          //   typeGender: {id: 1, nama: ["Men", "Men"]}
          //   userYangMendaftarkan: 68104779
          // })
        }

      }

      return output
    }
  },
  date_time: {
    formToRequestBody(date, time){
      // tell dayjs how to parse the input string
      var dayjsObj = dayjs(date + time, 'YYYY-MM-DDLT');

      return dayjsObj.format('YYYY-MM-DDTHH:mm:s');
    },
    responseBodyToRender(date, locale){
      let result

      if(locale){
        result = dayjs(date).locale(locale).format(locale === 'id' ? 'LLLL' : 'llll');
      } else {
        result = dayjs(date).format('llll');
      }

      return result
    }
  }
}

export default subAdapter
